/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Rag_Title_1Inputs */

const en_svc_rag_title_1 = /** @type {(inputs: Svc_Rag_Title_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`RAG systems that answer`)
};

const lv_svc_rag_title_1 = /** @type {(inputs: Svc_Rag_Title_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`RAG sistēmas, kas atbild`)
};

/**
* | output |
* | --- |
* | "RAG systems that answer" |
*
* @param {Svc_Rag_Title_1Inputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const svc_rag_title_1 = /** @type {((inputs?: Svc_Rag_Title_1Inputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Rag_Title_1Inputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_svc_rag_title_1(inputs)
	return en_svc_rag_title_1(inputs)
});